import { FC } from 'react';
import { useKnowledgeNodes } from '@/entities/knowledge';
import { KnowledgeNodeSuggestionsList } from './KnowledgeNodeSuggestionsList';

type Props = {
  /** Текст, набранный после знака `@`; сужает список узлов */
  query: string;
  onSelect: (nodeId: number) => void;
};

/** Узлы знаний, предлагаемые к подстановке в комментарий. */
export const KnowledgeNodeSuggestions: FC<Props> = ({ query, onSelect }) => {
  const { data } = useKnowledgeNodes({ limit: 20, isDeleted: false, search: query || undefined });
  const nodes = data?.knowledgeNodes ?? [];

  if (nodes.length === 0) return null;

  return <KnowledgeNodeSuggestionsList nodes={nodes} onSelect={onSelect} />;
};
